import reportsProgressMilestone from './reportsProgressMilestone';
import list from './list';
import reportsProgressStatuses from './reportsProgressStatuses';
import reportsProgressSchedule from './reportsProgressSchedule';
import reportsProgressPortfolio from './reportsProgressPortfolio';
import reportsProgressMonth from './reportsProgressMonth';
import reportsBudgetProject from './reportsBudgetProject';
import reportsBudgetMonth from './reportsBudgetMonth';
import reportsTimeMonth from './reportsTimeMonth';
import reportsTimeProject from './reportsBudgetProject';

export default {
  list,
  reportsProgressMilestone,
  reportsProgressStatuses,
  reportsProgressSchedule,
  reportsProgressPortfolio,
  reportsProgressMonth,
  reportsBudgetProject,
  reportsBudgetMonth,
  reportsTimeMonth,
  reportsTimeProject,
};
